import { RX0009 } from "../rxTypeCode";

export const CLEANUP = "CLEANUP" + RX0009;
export const SET_LOADING = "SET_LOADING" + RX0009;
export const SET_MODALVISIBLE = "SET_MODALVISIBLE" + RX0009;
export const SET_UPLOADEDFILES = "SET_UPLOADEDFILES" + RX0009;
export const SET_UPLOADEDFILETYPES = "SET_UPLOADEDFILETYPES" + RX0009;
export const SET_SELECTEDTYPE = "SET_SELECTEDTYPE" + RX0009;
export const ADD_UPLOADEDFILE = "ADD_UPLOADEDFILE" + RX0009;
export const ADD_UPLOADEDFILETYPE = "ADD_UPLOADEDFILETYPE" + RX0009;
export const ADD_UPLOADEDFILENAME = "ADD_UPLOADEDFILENAME" + RX0009;
export const ADD_UPLOADEDFILESIZE = "ADD_UPLOADEDFILESIZE" + RX0009;
export const DELETE_UPLOADEDFILE = "DELETE_UPLOADEDFILE" + RX0009;
